import { z } from 'zod';
import { idSchema, localeSchema, softDeleteTimestampsSchema } from './common.js';
/**
 * Usuario tal y como lo devuelve el API. `passwordHash` no aparece aquí ni
 * en ningún otro esquema: nunca sale del backend.
 */
export const userSchema = z
    .object({
    id: idSchema,
    email: z.email(),
    name: z.string().min(1).max(120),
    avatarUrl: z.string().max(500).nullable(),
    locale: localeSchema,
    isActive: z.boolean(),
})
    .extend(softDeleteTimestampsSchema.shape);
/** `POST /auth/login` */
export const loginRequestSchema = z.object({
    email: z.email(),
    password: z.string().min(1).max(200),
});
/** `PATCH /users/me` — solo el propio usuario edita estos campos. */
export const updateMeRequestSchema = z
    .object({
    name: z.string().min(1).max(120),
    locale: localeSchema,
    avatarUrl: z.string().max(500).nullable(),
})
    .partial()
    .refine((value) => Object.keys(value).length > 0, {
    message: 'Se requiere al menos un campo',
});
/** `POST /users/me/password` */
export const changePasswordRequestSchema = z.object({
    current: z.string().min(1).max(200),
    new: z.string().min(9).max(200),
});
/**
 * Datos con los que se crea un usuario. No hay registro público: solo lo usa
 * `scripts/create-user.ts`.
 */
export const createUserInputSchema = z.object({
    email: z.email(),
    name: z.string().min(1).max(120),
    password: z.string().min(9).max(200),
    locale: localeSchema.default('es'),
});
//# sourceMappingURL=user.js.map